/**
 * Design Tokens for Price Brothers Theme
 * 
 * Extends the base rise theme tokens with Price Brothers branding.
 */

import type { DesignTokens } from '@vibesites/tokens';
import { tokens as baseTokens } from '@vibesites/theme-rise/tokens';
import { defaultTokens } from '@vibesites/tokens';

/**
 * Price Brothers brand colors and typography.
 * Customize these values to match your brand guidelines.
 */
export const tokens: Partial<DesignTokens> = {
  color: {
    ...defaultTokens.color,
    ...baseTokens.color,
    // Price Brothers brand colors - customize these
    // primary: '#your-primary-color',
    // secondary: '#your-secondary-color',
    // accent: '#your-accent-color',
  },
  font: {
    ...defaultTokens.font,
    ...baseTokens.font,
    // Price Brothers typography - customize these
    // heading: '"Your Heading Font", serif',
    // body: '"Your Body Font", sans-serif',
  },
};

export default tokens;
